import React, { useEffect, useState } from "react";
import { getIcon } from "./iconDict";
import Colors from "../../colors";
import { Container, Stack } from "@mui/material";
import ConfirmationModal from "../modals/ConfirmationModal";


function ControlMeasureLabeledIconWithModal({
    name, isEditable,
    selectedControlMeasures, setSelectedControlMeasureCallback }) {
    const [controlMeasureSelected, setControlMeasureSelected] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const icon = getIcon(name)

    useEffect(() => {
        if (selectedControlMeasures) {
            setControlMeasureSelected(selectedControlMeasures.includes(name));
        }
    }, [name, selectedControlMeasures]);

    const iconOnClick = () => {
        if (isEditable) {
            if (controlMeasureSelected) {
                setModalVisible(true);
            } else {
                setModalVisible(true);
            }
        }
    };

    const confirmationButtonOnClickHandler = () => {
        setSelectedControlMeasureCallback(name)
        setModalVisible(false);
    };


    return (
        <>
            {/* Labeled Icon */}
            <Stack
                onClick={iconOnClick}
                sx={{
                    background: controlMeasureSelected ? Colors.lightGreen : Colors.white,
                    textAlign: 'center',
                    justifyContent: 'center',
                    paddingTop: '15px',
                    paddingBottom: '5px',
                    boxShadow: '0px 0px 25px -2px rgba(0, 0, 0, 0.1)',
                    minHeight: '100px'
                }} >
                <Container>
                    {icon}
                </Container>
                <Container sx={{ wordBreak: 'break-word', paddingLeft: '2px', paddingRight: '2px' }}>
                    {name}
                </Container>
            </Stack>

            {/* Confirmation Modal */}
            {!controlMeasureSelected && <ConfirmationModal
                isVisible={modalVisible}
                setIsVisible={setModalVisible}
                title={`Confirm "${name}" Control Measure is in place?`}
                mainAction={'Confirm'}
                mainActionHandler={confirmationButtonOnClickHandler}
                color={Colors.green} />}

            {/* Remove Control Measure modal */}
            {controlMeasureSelected && <ConfirmationModal
                isVisible={modalVisible}
                setIsVisible={setModalVisible}
                title={`Remove "${name}" from list of Control Measures in place?`}
                mainAction={'Remove'}
                mainActionHandler={confirmationButtonOnClickHandler} />}
        </>
    )
}
export default ControlMeasureLabeledIconWithModal;